module.exports = __webpack_public_path__ + "static/media/Photo2.cd7501be.jpg";